import axios from 'axios';
import { toTitleCase } from '../../helper';
import { theme } from '../../theme/theme';
import { LOAD_API_DATA, SET_API_DATA } from './dataAssets.type';
import axiosInstance from '../../axiosInstanceSetup';

export const getdataAssets = () => {
    return async (dispatch, getState, { endpoint }) => {
      dispatch({
        type: LOAD_API_DATA,
        payload: { apiField: "dataAssestsList" },
      });
      axiosInstance.get(`${endpoint}${process.env.REACT_APP_GET_ASSETS}`)
        .then(response => {
          // Handle success
          if (response.data.status === "success") {
            dispatch({
              type: SET_API_DATA,
              payload: {
                apiField: "dataAssestsList",
                data: response.data.data,
                status: "success",
              },
            })
            dispatch({
              type: SET_API_DATA,
              payload: {
                apiField: "dataAssestsDetails",
                data: 
                Object.keys(response.data.metrics).map((val)=>{
                  if(val === "quality_score"){
                    return {title: `${toTitleCase(val)}`,value:`${response.data.metrics[val]}%`,color:response.data.metrics[val]>95?theme.colors.success:response.data.metrics[val]<91?theme.colors.fail:theme.colors.primary}
                  }
                  return {title: toTitleCase(val),value:response.data.metrics[val],color:theme.colors.primary}
                }),
                status: "success",
              },
            })
          }
        })
        .catch(error => {
          // Handle error
          console.error('Error:', error);
        });
    };
  };

export const getDataAssetsUserDetails = () => {
    return async (dispatch, getState, { endpoint }) => {
      dispatch({
        type: LOAD_API_DATA,
        payload: { apiField: "userDetails" },
      });
      axiosInstance.get(`${endpoint}${process.env.REACT_APP_GET_USER_DETAILS}`)
        .then(response => {
          // Handle success
          if (response.data.status === "success") {
            dispatch({
              type: SET_API_DATA,
              payload: {
                apiField: "userDetails",
                data: response.data.data,
                status: "success",
              },
            })
          }
        })
        .catch(error => {
          // Handle error
          console.error('Error:', error);
        });
    };
  };
 